import {
  SEQUENCE_LIST_INIT,
  SEQUENCE_LIST_FETCHED,
  SEQUENCE_LIST_FAIL,
  SEQUENCE_DETAIL_SET,
  SEQUENCE_DETAIL_CLEAR,
} from "../actions/Sequence.action";

const initialState = {
  list: [],
  total: 0,
  page: 0,
  limit: 20,
  is_fetching: false,
  error: null,
  detail: null,
};

export default function sequenceReducer(state = initialState, action) {
  switch (action.type) {
    case SEQUENCE_LIST_INIT:
      return { ...state, is_fetching: true, error: null };
    case SEQUENCE_LIST_FETCHED: {
      const p = action.payload || {};
      return {
        ...state,
        is_fetching: false,
        list: p.list || [],
        total: p.total || 0,
        page: p.page || 0,
        limit: p.limit || 20,
      };
    }
    case SEQUENCE_LIST_FAIL:
      return { ...state, is_fetching: false, error: action.payload };
    case SEQUENCE_DETAIL_SET:
      return { ...state, detail: action.payload };
    case SEQUENCE_DETAIL_CLEAR:
      return { ...state, detail: null };
    default:
      return state;
  }
}
